
<template>
  <div class="carousel" :class="[rightClick?'rightClick':'']" ref="carousel">
    <p class="to_left" @click="toPrev"><img :src="bannerOptions.leftIcon" alt=""></p>
    <p class="to_right" @click="toNext"><img :src="bannerOptions.righIcon" alt=""></p>
    <div class="carousel_item" v-for="item in imgs" :key="item.id" :class="item.className">
      <div class="box">
        <div class="mask" v-if="item.id!==currentImgId"></div>
        <img class="img" :src="item.img" alt="">
        <!-- <p class="textbox"><span class="text">{{item.text}}</span></p> -->
      </div>

    </div>
  </div>
</template>
 
<script>
export default {
	props:{
         bannerOptions: {
			type:Object,
			default:()=>null
		 }
	},
  data: function () {
    return {
      imgs: [
        // {
        //   img: require('../../assets/images/cardbaner1.png'),
        //   id: 1,
        //   className: '',
        //   text: '北京市朝阳区先进党组织',
        // },
        // {
        //   img: require('../../assets/images/cardbaner2.png'),
        //   id: 2,
        //   className: '',
        //   text: '北京市朝阳区先进党组织',
        // },
        // {
        //   img: require('../../assets/images/cardbaner3.png'),
        //   id: 3,
        //   className: '',
        //   text: '北京商务中心区党工委先进党组织',
        // },
        // {
        //   img: require('../../assets/images/cardbaner4.png'),
        //   id: 4,
        //   className: '',
        //   text: '八里庄街道工委先进党组织',
        // },
        // {
        //   img: require('../../assets/images/cardbaner5.png'),
        //   id: 5,
        //   className: '',
        //   text: 'AAA级信用企业',
        // },
        // {
        //   img: require('../../assets/images/cardbaner6.png'),
        //   id: 6,
        //   className: '',
        //   text: '武汉市总工会会员电影票指定供应商',
        // },
        // {
        //   img: require('../../assets/images/cardbaner7.png'),
        //   id: 7,
        //   className: '',
        //   text: '武汉市总工会会员服务卡特惠商户',
        // },
        // {
        //   img: require('../../assets/images/cardbaner8.png'),
        //   id: 8,
        //   className: '',
        //   text: '南京市市总工会会员服务平台合作伙伴',
        // },
        // {
        //   img: require('../../assets/images/cardbaner9.png'),
        //   id: 9,
        //   className: '',
        //   text: '昆明市市总工会“工惠卡”特惠商户',
        // },
      ], // 图片库
      tranplate: 300,
      scale: 1,
      currentImgId: 1, //当前的轮播图
      left1: 8,
    //   left2: 7,
      right1: 2,
    //   right2: 3,
      currentImg: {},
	  rightClick:false,
    }
  },
 
  methods: {
    changeStyle() {
      if (this.currentImg == 1) {
      }
    },
    // 向前一张
    toPrev() {
		this.rightClick=false
      if (this.currentImgId > 1) {
        this.currentImgId--
      } else {
        this.currentImgId = 8
        return
      }
    },
    // 向后一张
    toNext() {
		this.rightClick=true
      if (this.currentImgId < 8) {
        this.currentImgId++
      } else {
        this.currentImgId = 1
        return
      }
    },
    // 切换
    changeClassName(val) {
		console.log(val)
      for (const item of this.imgs) {
        if (item.id === val) {
          //   this.currentImg = item
          item.className = 'is-active'
		  this.$emit('tagChange',item)
        } else if (item.id === this.left1) {
          item.className = 'is-left1'
        } else if (item.id === this.left2) {
        //   item.className = 'is-left2'
        } else if (item.id === this.right1) {
          item.className = 'is-right1'
        } else if (item.id === this.right2) {
        //   item.className = 'is-right2'
        } else {
          item.className = ''
        }
      }
    },
  },
  computed: {
	getlength(){
		return this.imgs.length
	},
  },
  watch: {
    currentImgId(val) {
      console.log(val)
      switch (val) {
        case 1:
          this.left1 = 8
        //   this.left2 = 8
          this.right1 = 2
        //   this.right2 = 3
          break
        case 2:
          this.left1 = 1
        //   this.left2 = 9
          this.right1 = 3
        //   this.right2 = 4
          break
        case 3:
          this.left1 = 2
        //   this.left2 = 1
          this.right1 = 4
        //   this.right2 = 5
          break
        case 4:
          this.left1 = 3
        //   this.left2 = 2
          this.right1 = 5
         // this.right2 = 6
          break
        case 5:
          this.left1 = 4
         // this.left2 = 3
          this.right1 = 6
        //  this.right2 = 7
          break
        case 6:
          this.left1 = 5
         // this.left2 = 4
          this.right1 = 7
         // this.right2 = 8
          break
        case 7:
          this.left1 = 6
        //  this.left2 = 5
          this.right1 = 8
         // this.right2 = 9
          break
        case 8:
          this.left1 = 7
        //  this.left2 = 6
          this.right1 = 1
         // this.right2 = 1
          break
        case 9:
          this.left1 = 8
        //  this.left2 = 7
          this.right1 = 1
         // this.right2 = 2
          break

        default:
          break
      }
      this.changeClassName(val)
    },
	'bannerOptions':{
		handler(newVal,oldVal){
             if(newVal){
				console.log('asdjkasjdkashj',this.bannerOptions)
				this.imgs=JSON.parse(JSON.stringify(this.bannerOptions.datas)) 
				this.$nextTick(()=>{
					this.currentImg=this.imgs[0]
					this.changeClassName(1)
				})
			 }
		},
		deep:true,
		immediate:true,
	}
  },
  mounted() {
    
  },
  beforeDestroy() {},
}
</script>
 
<style lang="less" scoped>
.carousel {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  padding: 35px 100px;
  box-sizing: border-box;
  .to_left {
    cursor: pointer;
    width: 64px;
    height: 64px;
    position: absolute;
    top: 290px;
    left:80px;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
       width: 64px;
    height: 64px;
    }
  }
  .to_right {
    cursor: pointer;
    width: 64px;
    height: 64px;
    color: #ffffff;
    position: absolute;
    top: 290px;
    right: 50px;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
    height: 64px;
    }
  }
  .carousel_item {
    position: absolute;
    // left: 0;
    transform: translateX(385px);
    z-index: -1;

    &.is-active {
      transform: translateX(385px) scale(1);
      z-index: 100;
      transition: transform 1s;
    }
    &.is-left1 {
      transform: translateX(159px) scale(0.83);
      z-index: 9;
      transition: transform 1s;
    }
    // &.is-left2 {
    //   transform: translateX(-100px) scale(0.56);
    //   transition: transform 1s;
    //   z-index: 1;
    // }
    &.is-right1 {
      transform: translateX(615px) scale(0.83);
      transition: transform 1s;
      z-index: 10;
    }
    // &.is-right2 {
    //   transform: translateX(900px) scale(0.56);
    //   transition: transform 1s;
    //   z-index: 1;
    // }
  }
  .box {
    width: 276px;
    height: 550px;
    // padding: 30px 40px;
    box-sizing: border-box;
    position: relative;
    .img {
      width: 276px;
      height: 550px;
      //   transform: translateX(0px) scale(0.83);
    }
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 276px;
      height: 550px;
      background: rgba(255, 255, 255, 0.3);
    }
    .textbox {
      display: flex;
      justify-content: center;
      align-items: center;
      widows: 100%;
      height: 50px;
      .text {
        // width: 186px;
        height: 42px;
        border: 2px solid #ffffff;
        opacity: 1;
        text-align: center;
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 37px;
        color: #ffffff;
        padding: 0 30px;
        // box-sizing: border-box;
      }
    }
  }
}
.rightClick{
	.carousel_item{
	&.is-left1 {
      transform: translateX(159px) scale(0.83);
      z-index: 12 !important;
      transition: transform 1s;
    }
	}
}
</style>


// WEBPACK FOOTER //
// src/components/banner/cascadeBanner.vue